import classNames from "classnames";
import { useFormik } from "formik";
import CustomButton from "shared/components/common/customButton";
import CustomInput from "shared/components/common/customInput";
import CustomTextArea from "shared/components/common/customTextArea";
import { toastMessage } from "shared/components/common/toast";
import { ContactUsService } from "shared/services/general";
import { ContactVS } from "shared/utils/validation";
import styles from "./style.module.scss";

const initialValues: ContactForm = {
  subject: "",
  message: "",
};

const Contact = () => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: ContactVS,
    onSubmit: () => {
      handleContactForm();
    },
  });

  const {
    handleSubmit,
    values,
    touched,
    errors,
    isSubmitting,
    setSubmitting,
    resetForm,
    setFieldValue,
  } = formik;

  const handleContactForm = () => {
    setSubmitting(true);
    let payload = {
      subject: values?.subject,
      msg: values?.message,
    };
    ContactUsService(payload)
      .then(() => {
        resetForm();
        toastMessage("success", "Message Sent!");
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div
      className={classNames(
        "flex flex-col w-full md:w-1/2 gap-4 ps-0 pt-8 md:pt-0 md:ps-10",
        styles.mainContainer
      )}
    >
      <h3 className={classNames(styles.title)}>Get In Touch</h3>
      <p className={classNames(styles.desc)}>
        You can also get in touch with us by filling out the form below and we
        will get in contact with you as soon as possible.
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className={classNames("flex flex-col gap-2 w-full")}
      >
        <CustomInput
          label="Subject"
          placeholder="Subject"
          required
          value={values.subject}
          error={touched.subject && errors.subject ? errors.subject : ""}
          limit={255}
          showLimit
          onChange={(e: any) => {
            if (e.currentTarget.value.length <= 255) {
              setFieldValue("subject", e.currentTarget.value);
            }
          }}
          onPaste={(e: any) => {
            const pastedData = values.message + e.clipboardData.getData("Text");
            const truncatedData = pastedData.slice(0, 255);
            e.preventDefault();
            setFieldValue("subject", truncatedData);
          }}
        />
        <CustomTextArea
          label="Message"
          placeholder="Type your message here"
          required
          value={values.message}
          error={touched.message && errors.message ? errors.message : ""}
          onChange={(e: any) => {
            if (e.currentTarget.value.length <= 3000) {
              setFieldValue("message", e.currentTarget.value);
            }
          }}
          onPaste={(e: any) => {
            const pastedData = values.message + e.clipboardData.getData("Text");
            const truncatedData = pastedData.slice(0, 3000);
            e.preventDefault();
            setFieldValue("message", truncatedData);
          }}
          showLimit
          limit={3000}
        />

        <CustomButton
          title="Submit Message"
          style={{ width: "100%" }}
          onClick={() => {
            handleSubmit();
          }}
          disabled={isSubmitting}
          loading={isSubmitting}
        />
      </form>
    </div>
  );
};

export default Contact;
